module.exports = __webpack_public_path__ + "img/2.023853e9.jpg";